import React from 'react';
import './LabelForms.scss';
import TooltipFormComponent from '../TooltipForm/TooltipFormComponent';
interface ILabelForms {
	text: string;
	icon?: any;
	iconPosition?: 'start' | 'end';
	toolTipText?: React.ReactElement;
	toolTipPosition?: string;
	classname?: string;
	isMobile?: boolean;
}
const LabelForms: React.FC<ILabelForms> = ({
	text,
	icon,
	iconPosition,
	toolTipText,
	toolTipPosition,
	isMobile,
	classname
}) => {
	return (
		<>
			{iconPosition === 'start' ? (
				<div className='label-container'>
					<label>
						{icon}
						{text}
					</label>
				</div>
			) : (
				<div className='label-container '>
					<label>
						{text}
						{icon && (
							<TooltipFormComponent text={toolTipText || <></>}>{icon}</TooltipFormComponent>
						)}
					</label>
				</div>
			)}
		</>
	);
};

export default React.memo(LabelForms);
